import { parse } from 'query-string';

const isPrintMode = () => {
  const url = parse(window.location.search);
  return !!(url.print && url.print === 'true');
};

export default isPrintMode;
